/*

Functions:

	$('ul').setMenuWidth('width', 0-1000, true/false);
	
	$('ul').addFirstLast();  // add class first and last
	
	$('div').showRandom('number_of_children_to_display', 'speed');
	
	array = $.shuffle(array); // shuffle array
	$('div').shuffle(); // shuffle childrens
	
	$('slider').pt_scroller({ duration:18000, easing:'linear'}); // scroles one way <slider><div> ... content .... </div></slider>
	
	
	More on the bottom
*/




(function($) {
		  
		 
	$.fn.setMenuWidth = function(my_width, similarity, apply_on_li){
		
		if(my_width == 'auto'){
			my_width = $(this).width();
		}
		
		var menu = $(this);
		var a = Object();
		var li = Object();
		var menu_width = 0;
		var li_padding = 0;
		similarity = typeof(similarity) != 'undefined' ? similarity : 0;
		apply_on_li = typeof(apply_on_li) != 'undefined' ? apply_on_li : false;
		
		
		menu.children().each( function(){
			if($(this).hasClass('begin') == false && $(this).hasClass('end') == false) {
				a = $(this).find('a:first');
				if(a.width() > 0){
					a.css('padding-left', '0px');
					a.css('padding-right', '0px');
					a.css('width', 'auto');
					menu_width += parseInt(a.outerWidth()) + parseInt(similarity);
					
					my_width -= parseInt($(this).css("margin-left").replace("px", "")) + parseInt($(this).css("margin-right").replace("px", ""));
				}
			}
		});
		
		var offset = 0;
		var efectve_width = 0;

		menu.children().each( function(){
			if($(this).hasClass('begin') == false && $(this).hasClass('end') == false) {
				a = $(this).find('a:first');
				try{
					li_padding = parseInt($(this).css("padding-left").replace("px", "")) + parseInt($(this).css("padding-right").replace("px", ""));
				}catch(err){ li_padding = 0; }
				
				offset = parseInt(a.css('border-right-width'))*1 + parseInt(a.css('border-left-width'))*1;
				a.css('width', (Math.round((my_width * ($(a).outerWidth() + parseInt(similarity)) ) / menu_width) - offset - li_padding) +'px');
				if(apply_on_li) { $(this).css('width', a.css('width') ); }
				a.css('display', 'block');
				a.css('padding-left', '0px');
				a.css('padding-right', '0px');
				$(this).addClass('modified');
				
				efectve_width += a.outerWidth(true);
			}
		});
		
		var correction = efectve_width - my_width;
		
		var last_a = Object;
		
		try {
			if( menu.children().filter("li.begin").length )
			{
				last_a = menu.children().filter("li:last").prev().find('a');
			}else{
				last_a = menu.children().filter(":last").find('a');
			}
			
			last_a.css('width', parseInt(last_a.css('width')) - correction);
		}catch(err){}
		
		return($(this));
		
	}
	
	$.fn.addFirstLast = function(element){
			if(typeof element == 'undefined'){ element=''; }
			$(this).each(function(){
				if( $(this).children(element+".begin").length ){		
					$(this).children(element+":nth-child(2)").addClass("first");    
					$(this).children(element+":last-child").prev().addClass("last");
				}else{
					$(this).children(element+":nth-child(1)").addClass("first");    
					$(this).children(element+":last-child").addClass("last");
				}	
			});
	}
	
	$.fn.styleSelect = function(){
			var cform_counter = 0;
			
			$(this).each(function(index) {
				
				// vars
				var do_selector = 'do_cform_' + cform_counter;
				var s_width = $(this).outerWidth() - 25;
				var s_height = $(this).outerHeight();
				var s_line_height = $(this).css('line-height');
				var s_text = $(this).find('option:selected').text();
				// warp
				$(this).wrap('<div class="cform_relative_div" />');
				
				// select
				$(this).addClass('cform_hide_object');
				$(this).bind('change', function(e){
						$('.'+do_selector).text( $(this).find('option:selected').text() );	
				});
				
				// img
				var parent = $(this).parent();
				var img = 	$('<div/>', {
								'class' : 'cform_select_img',
								css : { width: s_width, height: s_height }
						 	});
				//span
				$('<span/>', {
				  	'class' : 'cform_slect_span ' + do_selector,
					text : s_text,
					css : { width: s_width, height: s_height }
				  }).appendTo(img);
				
				$(img).appendTo(parent);
				
				cform_counter++;
				
			});
	}
	
	
	$.fn.rowHover = function(){
			$(this).each(function(index) {
				$(this).bind('mouseover', function(){
					$(this).addClass('row_hover');	
				});
				$(this).bind('mouseout', function(){
					$(this).removeClass('row_hover');								   
				});
			});
	}
	
	$.fn.rowHighlight = function(){
			$(this).each(function(index) {
				$(this).addClass('color_row');
			});
	}
	
	$.fn.tableColumnNumeration = function(){
		$(this).each(function(){
			$(this).find('tr').each(function(){
				var x = 1;
				$(this).children('td').each(function(){
					$(this).addClass('col_'+x);
					x++;
				});
			});		  
		});
	}
	
	$.fn.disableInput = function(){
			$(this).each(function(index) {
				$(this).attr('autocomplete', 'off');
			});
	}
	
	$.fn.resizeInputs = function(){
			$(this).each(function(index) {
				$(this).css('width', $(this).parent().width() );
			});
	}
	
	
	$.fn.inputTextDefaultValue = function(strText, class_to_parent){
			
			$(this).attr('title', strText);
			
			if($(this).val() == "" || $(this).val() == strText){ $(this).val( strText ); $(this).addClass('input_text_default_value'); $(this).trigger('change'); }
			if($(this).val() != ""){ $(this).trigger('change'); }
			
			$(this).bind('focusout', function(e){
				if($(this).val() == "" || $(this).val() == strText){ $(this).val( strText ); $(this).addClass('input_text_default_value'); $(this).trigger('change'); }
				else if($(this).val() != ""){ $(this).removeClass('input_text_default_value'); $(this).trigger('change'); }
				if(class_to_parent){ $(this).parent().removeClass('input_text_default_value_active'); }else{ $(this).removeClass('input_text_default_value_active'); }
			});
			$(this).bind('mouseup', function(e){
				if($(this).val() == strText){
					var $this = $(this);
					setTimeout(function(){ $this.select(); }, 10);
				}
			});
			$(this).bind('focusin', function(e){
				if($(this).val() == strText){
					var $this = $(this);
					$this.select();
				}
			});
			$(this).bind('keyup focus', function(e){
				if(e.keyCode != 9){
					if($(this).val() == "" || $(this).val() == strText){ $(this).val(''); $(this).removeClass('input_text_default_value'); }
					else if($(this).val() != ""){ $(this).removeClass('input_text_default_value'); }
					if(class_to_parent){ $(this).parent().addClass('input_text_default_value_active'); }else{ $(this).addClass('input_text_default_value_active'); }
				}
			});
			
	}
	$.fn.inputTextDefaultValueSubmitCheck = function(){
		$(this).bindFirst('submit',function(e){
			$(this).find('.input_text_default_value').each(function(e){
				if($(this).val() == $(this).attr('title')){ 
					$(this).val(''); 
				}
			});
			return true;
		});
		
	}
	
	$.fn.inputTextDefaultMoveErrorUp = function(){
		$(this).find('.field_error').each(function(e){
				$(this).parent().addClass('field_error');
			return true;
		});
	}
	
	$.fn.showRandom = function(number, speed){
		var randorder = new Array();
		var i;
		for (i = 0; i < $(this).children().size(); i++){
			randorder[i] = i;
		}
		randorder = $.shuffle(randorder);
		var i = 0;
		while(i < number){
			$(this).children().eq(randorder[i]).fadeIn(speed).css('display', 'block');
			i++;
		}
	}
	
	
	$.fn.shuffle = function() {
	  return this.each(function(){
		var items = $(this).children();
		return (items.length)
		  ? $(this).html($.shuffle(items))
		  : this;
	  });
	}
	
	$.shuffle = function(arr) {
	  for(
		var j, x, i = arr.length; i;
		j = parseInt(Math.random() * i),
		x = arr[--i], arr[i] = arr[j], arr[j] = x
	  );
	  return arr;
	}
	
	$.fn.reverse = [].reverse;
	
	$.fn.pt_scroller = function(arr){
		
		var slider = $(this);
		$(this).css({ 'position':'relative', 'overflow':'hidden' });
		var slider_w = $(this).outerWidth();
		
		var slide = $(this).children(':first');
		var slide_w = 0;
		
		$(slide).children().each(function(){
			slide_w += $(this).outerWidth(true);	
		});
		
		$(slide).css({ 'float':'left', 'width':slide_w });
		
		var animated = jQuery('<div/>', {
			css: { 'position':'absolute', 'left':'0px', 'top':'0px', 'width':slide_w*2 }
		}).appendTo(slider);
		
		$(slide).clone().appendTo(animated);
		$(slide).appendTo(animated);
		
		
		$(animated).animate({	left:'-'+(animated.outerWidth()-slider_w)+'px' },
							{
								duration: arr.duration*2,
								easing: arr.easing,
								complete: function() {
									$(slider).pt_scroller_repeat(arr);
							}
						});
		
	}
	
	$.fn.pt_scroller_repeat = function(arr){
		
		var slider = $(this);
		var animated = $(this).children(':first');
		
		var slider_w = $(this).outerWidth();
		
		animated.css('left',	"-" + ((animated.outerWidth() / 2) - slider_w) + "px");
		$(animated).animate({	left:'-'+(animated.outerWidth()-slider_w)+'px' },
							{
								duration: arr.duration,
								easing: arr.easing,
								complete: function() {
									$(slider).pt_scroller_repeat(arr);
							}
						});
	}
	
	$.GetUrlID = function(tab_class){ 
		var strUrl = $(location).attr('href');
		var strUrlId = (strUrl.split("#")[1]);
		return strUrlId;
	}
	
	$.fn.pt_center_text = function(){
		var parent_height = 0;
		var my_height = 0;
		$(this).children().each(function(){
			objParent = $(this).parent().height();	
			my_height = $(this).height();
			
			$(this).css('top', Math.round(((objParent * 0.5) - (my_height * 0.5)).toString()) + 'px');
			
		});
	}
	
	$.fn.pt_set_same_size = function(includeMargin){
		
		if(includeMargin !== true) includeMargin = false;
		var max_height = 0;
		
		$(this).each(function(){
			if($(this).height() > max_height){
				max_height = $(this).outerHeight(includeMargin);
			}
		});
		
		$(this).each(function(){
			var padding_margin = $(this).outerHeight(includeMargin) - $(this).height();
			$(this).css('height', max_height - padding_margin);
		});
		
	}
	
	$.fn.textShadowPrepare = function(inner_or_out,tag){
		this.each(function(){
			if(inner_or_out == 'inner'){
				$(this).wrapInner($('<'+tag+' />')).wrapInner($('<div />', { 'class': 'text_shadow' }));
			}else{
				$(this).wrap($('<div />', { 'class': 'text_shadow' }));
			}
		});
	}
	$.fn.textShadow = function(){
		$('.text_shadow').each(function(){
			var oryginal = $(this).children(':first');
			var shadow = oryginal.clone();
			var clear = $('<div />', { 'class': 'clear' });
			oryginal.after(clear);
			oryginal.after(shadow);
			oryginal.addClass('shadow');
		});
		
	}
	$.fn.bindFirst = function(name, fn) {
		this.bind(name, fn);

		if (typeof this.data('events') != 'undefined' && this.data('events') != null)
		{
			var handlers = this.data('events')[name.split('.')[0]];
			// take out the handler we just inserted from the end
			var handler = handlers.pop();
			// move it at the beginning
			handlers.splice(0, 0, handler);
		}
	};
	
	
	$.fn.initSlider = function() {
		
		var slides = $(this).find('.slde_item');
		
		if(slides.length > 1)
		{
			var menu = $('<div />', { 'class':'slde_nav' });
			slides.each(function(index, element)
			{
				var title = $(element).find('.slde_menu_item').html();
				$(element).find('.slde_menu_item').remove();
				menu.append( $('<a />', { 'class':'slde_nav_item', 'href':'#', 'id':'nav_'+index, 'text':title }) );		 
			});
			
			$(this).after(menu);
		}
		else
		{
			$(this).addClass('one_slide');
		}
		
		
	};

})(jQuery);


$(document).bind('before_ready',function(){

	// SLIMBOX2 -  AUTOLOAD CODE BLOCK (MAY BE CHANGED OR REMOVED)
	if (!/android|iphone|ipod|series60|symbian|windows ce|blackberry/i.test(navigator.userAgent)) {
		jQuery(function($) {
			$("a[rel^='lightbox']").slimbox({/* Put custom options here */}, null, function(el) {
				return (this == el) || ((this.rel.length > 8) && (this.rel == el.rel));
			});
		});
	}
	
	
	/* Location */
	$('.succ_slider').cycle({
		fx: 'scrollHorz',
		speed: 500,
		pause: 1,
		timeout: 7000,
		delay: 500,
		random: 1,
		pager: '#location_nav ul',
		next:'.succ_next',
		prev:'.succ_prev',
		cleartypeNoBg:true
	}); 
	
	
	$('.play_open').bind('click', function(){
										   
		var playBox = $(this).parents('.play');
		
		playBox.find('.play_dialog').dialog({
			  title: "<strong>Watch Video</strong>",
			  resizable: false,
			  width: 700,
			  height: 500,
			  position: ['center',60],
			  dialogClass:'js_website_dialog_container',
			  modal: true,
			  create: function(){
				  var iframe = playBox.find('.play_embed iframe').clone();
				  iframe.attr('src', iframe.attr('src') + '&autoplay=1');
				  $(this).append(iframe);
			  },
			  close:function(){
				  $(this).dialog( "destroy" ).html('');
				  playBox.find('.play_border').append($(this));
			  }
		});
		
	});
	
	/* Slider */
	$('.slde_slider').initSlider();
	/* Slider */
	
	/* Location */
	var nav = $('#location_nav ul');
	var content = $('.location_content');
	nav.html('');
	
	$('.addr_full').each(function()
	{
		nav.append($(this).find('.addr_link li'));
		$(this).find('.addr_link').remove();
		
	});
	nav.children(':first').addClass('activeSlide');
	
	
	$('.slde_nav').addFirstLast();
	$('.foot_menu').addFirstLast();
	$('.menu').addFirstLast();
	
	
	
	
});


$(document).ready(function(){
	$('.menu__menu_main_top').dropDownMenu({parentMO: 'parent-hover', childMO: 'child-hover1'});
	
	if($('.post_scrollbar').length)
	{
		$('.post_scrollbar').tinyscrollbar();
		$('.post_scrollbar').bind('new_content', function(){
			$(this).tinyscrollbar_update();											  
		});
	}
	
	
	
	/* SUB-MENU ADJUST */
	$('.menu__menu_main_top li').bind('mouseenter', function(event){
		
		var menu = $(this).children('ul');
		if( menu.length )
		{
			var positions = menu.offset();
			var element_w = menu.outerWidth(true);
			
			if(positions.left < 0)
			{
				if(menu.css('right') != 'auto')
				{
					menu.css('left', menu.css('right') );
					menu.css('right', 'auto');
				}
				
			}else if((positions.left + element_w) > $(window).width())
			{
				if(menu.css('left') != 'auto')
				{
					menu.css('right', menu.css('left') );
					menu.css('left', 'auto');
				}
			}
		}
		
	});
	
	/*
	
	// Hide links going outside of main box
	if( $('.main').length)
	{
		var main_links = $('.main ul.menu');
		var main_box = $('.main_border');
		var main_box_h = main_box.height();
		var main_links_h = main_links.height();
		var main_box_content_h = $('.main h1').outerHeight(true); $('.main p').each(function(){ main_box_content_h += $(this).outerHeight(true); });
		var free_space_h = main_box_h - main_box_content_h;
		var links_to_hide = 0;
		
		// hide links
		main_links.find('li').not('.begin').not('.end').reverse().each(function()
		{
			if( main_links.height() > free_space_h )
			{
				$(this).hide();
				links_to_hide++;
			}
		});
		
		
		
		// Randomize links
		main_links.find('li').not('.begin').not('.end').show();
		var lins_array = main_links.find('li').not('.begin').not('.end');
		$.shuffle(lins_array);
		for(x=0; x<links_to_hide; x++)
		{
			$(lins_array[x]).hide();
		}
		
	}
	
	*/
});  
$(window).on('load', function(){
	/* Location */
	$('.location_content').cycle({
		fx: 'fade',
		speed: 500,
		pause: 1,
		timeout: 7000,
		delay: 500,
		pager: '#location_nav ul',
		cleartypeNoBg:true
	}); 
	
	$('#location_nav a').click(function(){
		$('.big_google_maps').each( function(){ $(this).gmap3({trigger:"resize"}); });
	});
	
	/* Addr Slider */
	$('.addr_slider').cycle({
		fx: 'scrollHorz',
		speed: 500,
		pause: 1,
		timeout: 7000,
		delay: 500,
		next: '#addr_next',
		cleartypeNoBg:true
	}); 
	if($('.addr_slider').children().length > 1){
		$('#addr_next').bind('click', function(){
			$('.small_google_maps').each( function(){ $(this).gmap3({trigger:"resize"}); });
			$('.addr_slider').cycle('pause');
		});
	}else{
		$('#addr_next').remove();
	}
	/* Addr Slider */
	
	
	/* Prof Slider */
	$('.prof_slider').cycle({
		fx: 'scrollHorz',
		speed: 500,
		pause: 1,
		timeout: 7000,
		delay: 500,
		next: '#prof_next',
		cleartypeNoBg:true
	}); 
	if($('.prof_slider').children().length > 1){
		$('#prof_next').bind('click', function(){
			$('.prof_slider').cycle('pause');
		});
	}else{
		$('#prof_next').remove();
	}
	/* Prof Slider */
	
	
	/* Orga Slider */
	var w = 0;

	var orga_duration = 18000;
	
	if(typeof(document.orga_duration) != 'undefined')
		orga_duration = document.orga_duration;
	
	$('.orga_slider img').each(function(){
		w += $(this).outerWidth(true);	
	});
	
	
	if( w >= $('.orga_border').width() )
	{
		$('.orga_slider').pt_scroller({ duration:orga_duration, easing:'linear'});
	}	
	
	/* Orga Slider */
	
	
	
	
});  				   

$(document).ready(function(){	
	
	//next 3 days date banner
	if ($(".next_3_days").length > 0){
		var date =new Date();
		//use the constructor to create by milliseconds
		var nex_3_days = new Date(date.getTime() + 3*24 * 60 * 60 * 1000);
		var day = nex_3_days.getDate();
		var month = nex_3_days.getMonth() + 1;
		var year = nex_3_days.getFullYear();
		
		day = day+"";
		month = month+"";
		year = year+"";
		
		if(day.length == 1)
			day = '0'+day;
		
		if(month.length == 1)
			month = '0'+month;
		
		
		var str_date = month+'/'+day+'/'+year;
		$(".next_3_days").html(str_date);
	}
	/*
	if ( $.browser.msie ) {
		$('.head_phone_text').textShadowPrepare('inner', 'div');
		$.fn.textShadow();
	}
	*/
	//if ( $.browser.msie ) $.fn.textShadow();
	
	//$('#menu').setMenuWidth('960','100', true); - set menu with for ul list
	//$('.menu').addFirstLast(); - add first and last class
	//$('.table tr').rowHover(); - create hover for table
	//$('.table tr').rowHighlight(); - create highlight class
	
	//$('#input').inputTextDefaultValue('text'); - set default text for imput field
	//$('form').inputTextDefaultValueSubmitCheck(); - clear defaults befor sending form
	
	//$.GetUrlID(); - get url hash
	
	//$('.div').pt_center_text(); - center verticaly div in another div
	//$('.box').pt_set_same_size(); - make boxes same size
	
	//$('.table_col_num').tableColumnNumeration(); - add col_1,2,3.. to td in table
	
	
});

/*other functions*/

function is_email(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
    
  }

/*
e.g.

<form id="form_appointment">
   <input id="user_fname" />
   <input id="user_lname" />
   <input id="user_phone" />
   <input id="user_email" />
</form>

// Place under the form (no document ready needed)
//Set up default fields value, clear them on focus, and set up back while left empty
$('.form_appointment #user_fname').inputTextDefaultValue( "First Name:" );
$('.form_appointment #user_lname').inputTextDefaultValue( "Last Name:" );
$('.form_appointment #user_phone').inputTextDefaultValue( "Phone Number:" );
$('.form_appointment #user_email').inputTextDefaultValue( "Email Address:" );
//clear default values before submit and set it up again on page load
$('#form_appointment').inputTextDefaultValueSubmitCheck(); 


<ul class="menu_top">
  <li class="begin"></li>
  <li><a>Home</a></li>
  <li><a>About</a></li>
  <li><a>Contact</a></li>
  <li class="end"></li>
</ul>
// automatic a with with display block
// can be use with begin/end class' (if needed for styling)
$('.menu_top').setMenuWidth('960');



<div class="random">
  <a/>
  <div/>
  <.../>
</div>

// shows 3 random children using slow fade trans.
$('.random').showRandom(3, 'slow');

// shuffle tags positions in dive
$('.random').shuffle();


// resize inputs to 100% width of parent (solve comp issues)
$('.some_form input').resizeInputs();

// add/remove class on hover (solve comp issues with using :hover with nested elements)
$('some_container someTag').rowHover();

// add class (works even with begin/end class' - then sec and pre-last get first/last class)
$('ul').addFirstLast();

*/

function human_track(){
    boolDone = false;
    $(window).bind("scroll resize mousemove click", function(e){
	if(!boolDone)
	{
	    boolDone = true

	    $.AjaxInit({
		'strContentSelector':'.listing_contact_us_form',
		'strUrl': '/ajax.html',
		'strData': '',
		'strExtraData': 'ajax_handle=human_track&type='+e.type
	    });
	}    
    });
    
}
